/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/DocumentDataExtractor.yaml
import { ScanbotDocumentDataExtractorImpl } from './impl';
/**
 * Entry point for all Document Data Extractor features.
 */
export const ScanbotDocumentDataExtractor = {
    /**
     * Opens the Ready-To-Use UI Document Data Extractor screen with the desired configuration.
     * @param {DocumentDataExtractorScreenConfiguration} configuration - The Document Data Extractor configuration to be used for extracting.
     * @returns {Promise<ResultWrapper<DocumentDataExtractorUiResult>>} - The result of the Document Data Extractor operation.
     */
    async startExtractorScreen(configuration) {
        return ScanbotDocumentDataExtractorImpl.startExtractorScreen(configuration);
    },
    /**
     * Extracts data from a given image with the desired configuration.
     * @param {ImageInput} params.image - The image to be used for extracting.
     * @param {DocumentDataExtractorConfiguration} params.configuration - The Document Data Extractor configuration to be used for extracting.
     * @returns {Promise<DocumentDataExtractionResult>} - The result of the Document Data Extractor operation.
     */
    async extractFromImage(params) {
        return ScanbotDocumentDataExtractorImpl.extractFromImage(params);
    },
    /**
     * Verifies document parts.
     * @param {GenericDocument[]} documentParts - The document parts to be used for verifying.
     * @returns {Promise<DocumentVerificationReport>} - The result of the Document Verification operation.
     */
    async verifyDocument(documentParts) {
        return ScanbotDocumentDataExtractorImpl.verifyDocument(documentParts);
    },
};
//# sourceMappingURL=DocumentDataExtractor.js.map